import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Lock Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 44a2.89 2.89 0 0 1-2.118-.881A2.89 2.89 0 0 1 8 41V19.3q0-1.237.882-2.119A2.9 2.9 0 0 1 11 16.3h3.5v-4.8q0-3.942 2.78-6.721T24.007 2t6.719 2.779T33.5 11.5v4.8H37a2.9 2.9 0 0 1 2.119.881A2.9 2.9 0 0 1 40 19.3V41q0 1.237-.881 2.119A2.9 2.9 0 0 1 37 44zm0-3h26V19.3H11zm13.009-7q1.59 0 2.716-1.101c1.126-1.102 1.125-1.618 1.125-2.649q0-1.5-1.134-2.725T23.991 26.3q-1.59 0-2.716 1.225-1.125 1.225-1.125 2.75c0 1.525.378 1.892 1.133 2.625q1.134 1.1 2.725 1.1M17.5 16.3h13v-4.8q0-2.709-1.894-4.604T24.006 5 19.4 6.896q-1.9 1.895-1.9 4.604z"
    }, null, -1)
  ])))
}
export default { render: render }